import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { FaChevronDown } from "react-icons/fa";
import { FORM_LANGS } from "../Assets/LanguageTabs";

const LanguageSelector: React.FC = () => {
  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const [lang, setLang] = useState("en");
  const langRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const storedLang = localStorage.getItem("lang") || "en";
    setLang(storedLang);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (langRef.current && !langRef.current.contains(e.target as Node)) {
        setLangMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const changeLanguage = (selectedLang: string) => {
    localStorage.setItem("lang", selectedLang);
    setLang(selectedLang);
    setLangMenuOpen(false);
    window.location.reload(); // optional: reload to reflect changes
  };

  const current = FORM_LANGS.find((l) => l.code === lang) || FORM_LANGS[0];

  return (
    <div className="relative" ref={langRef}>
      <button
        onClick={() => setLangMenuOpen(!langMenuOpen)}
        className="flex items-center gap-2 text-gray-800 hover:text-gray-600"
        title="Select Language"
        aria-label="Select Language"
      >
        <Icon icon={current.flag} className="w-6 h-auto rounded-sm shadow-sm" />
        <FaChevronDown className="text-xs" />
      </button>
      {langMenuOpen && (
        <div className="absolute right-0 mt-2 w-32 bg-white shadow-lg rounded-md z-10 overflow-hidden">
          {FORM_LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => changeLanguage(l.code)}
              className={`flex w-full items-center gap-3 px-4 py-2 text-left hover:bg-gray-50 ${
                lang === l.code ? "bg-gray-100 font-bold" : ""
              }`}
            >
              <Icon icon={l.flag} className="w-6 h-auto rounded-sm shadow-sm" />
              {l.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
